import React from 'react'
import { connect } from 'react-redux'
import LinearProgress from 'material-ui/LinearProgress'

class GeneralProgressLoader extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      progressVisible: this.props.progressVisible
    }
  }

  componentWillReceiveProps (nextProps) {
    this.setState({
      progressVisible: nextProps.progressVisible
    })
  }

  render = () => {
    return this.state.progressVisible ? (
      <LinearProgress className={'progress-bar'} mode={'indeterminate'} />
    ) : ''
  }
}

const mapStateToProps = (state, props) => {
  return {
    progressVisible: state.progressVisible
  }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GeneralProgressLoader)



// WEBPACK FOOTER //
// ./src/components/progressbarr/GeneralProgressLoader.js